export const setValue = (newValue) => {
    return {
        type: 'SET_DECISION',
        payload: newValue,
    };
};